const version = "7.17.0";
export {
  version
};
//# sourceMappingURL=package.json.js.map
